import GlobalApiRefetcher from "../../GlobalApiRefetcher";
import ProtectedRoute from "../Routes/ProtectedRoute";
import ProtectedLayout from "./ProtectedLayout";

const ProtectedPageLayout = ({ children, ...layoutProps }) => {
  return (
    <ProtectedRoute>
      <GlobalApiRefetcher />
      <ProtectedLayout {...layoutProps}>{children}</ProtectedLayout>
    </ProtectedRoute>
  );
};

export default ProtectedPageLayout;
